import React from 'react'
import styled from 'styled-components'

const StyledLoading = styled.div`
  .pacman {
    margin: 40px 10px;
  }

  .pacman-top {
    background-color: #fa8a3b;
    height: 100px;
    width: 200px;
    border-radius: 100px 100px 0 0;
    animation: spin1 0.5s infinite linear;
  }

  .pacman-bottom {
    background-color: #fa8a3b;
    height: 100px;
    width: 200px;
    border-radius: 0 0 100px 100px;
    animation: spin2 0.5s infinite linear;
  }

  .feed {
    margin-top: -185px;
    margin-left: 15px;
    width: 45px;
    height: 45px;
    border-radius: 30%;
    -moz-animation: eat 1s linear 0s infinite;
    -webkit-animation: eat 1s linear 0s infinite;
    animation: eat 1s linear 0s infinite;
  }

  /* Animation*/

  @keyframes spin1 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-35deg);
    }
  }
  @keyframes spin2 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(35deg);
    }
  }

  @-moz-keyframes spin1 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-35deg);
    }
  }
  @-moz-keyframes spin2 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(35deg);
    }
  }

  @-webkit-keyframes spin1 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-35deg);
    }
  }
  @-webkit-keyframes spin2 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(35deg);
    }
  }

  @keyframes eat {
    0% {
      box-shadow: 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black, 700px 65px 0 0 black,
        900px 65px 0 0 black, 1100px 65px 0 0 black, 1300px 65px 0 0 black;
    }

    100% {
      box-shadow: 0px 65px 0 0 black, 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black,
        700px 65px 0 0 black, 900px 65px 0 0 black, 1100px 65px 0 0 black;
    }
  }

  @-moz-keyframes eat {
    0% {
      box-shadow: 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black, 700px 65px 0 0 black,
        900px 65px 0 0 black, 1100px 65px 0 0 black, 1300px 65px 0 0 black;
    }

    100% {
      box-shadow: 0px 65px 0 0 black, 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black,
        700px 65px 0 0 black, 900px 65px 0 0 black, 1100px 65px 0 0 black;
    }
  }

  @-webkit-keyframes eat {
    0% {
      box-shadow: 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black, 700px 65px 0 0 black,
        900px 65px 0 0 black, 1100px 65px 0 0 black, 1300px 65px 0 0 black;
    }

    100% {
      box-shadow: 0px 65px 0 0 black, 100px 65px 0 0 black, 300px 65px 0 0 black, 500px 65px 0 0 black,
        700px 65px 0 0 black, 900px 65px 0 0 black, 1100px 65px 0 0 black;
    }
  }
`

const Loading = () => (
  <StyledLoading>
    <div className="pacman" />
    <div className="pacman-top" />
    <div className="pacman-bottom" />
    <div className="feed" />
  </StyledLoading>
)

export default Loading
